import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/auth';
import { cn } from 'lib/utils';
import { RESTRICTED_PRODUCTS_ROUTES } from 'lib/routes';

import * as S from './styles';

type Route = {
  title: string;
  path: string;
  blockedRoles?: string[];
};

const ROUTES: Route[] = [
  {
    title: 'Registro de eventos',
    path: RESTRICTED_PRODUCTS_ROUTES.list().url,
  },
  {
    title: 'Importar planilhas',
    path: RESTRICTED_PRODUCTS_ROUTES.importFiles().url,
  }
];

export const TabbedNavigation = ({
                                   className,
                                   ...props
                                 }: React.HTMLAttributes<HTMLDivElement>) => {
  const location = useLocation();
  const { profile } = useAuth();

  const isRouteActive = React.useCallback(
    (path: string) => {
      if (path.includes('#')) {
        const [pathname, hash] = path.split('#');
        return location.pathname === pathname && location.hash === `#${hash}`;
      }

      return location.pathname === path;
    },
    [location.pathname, location.hash],
  );

  return (
    <div {...props} className={cn('flex flex-col w-full mb-6', className)}>
      <S.Container>
        {ROUTES.map((route) => (
          !route.blockedRoles?.includes(profile?.type || '') && (
            <S.Button
              key={route.path}
              to={route.path}
              className={isRouteActive(route.path) ? 'active' : ''}
            >
              {route.title}
            </S.Button>
          )
        ))}
      </S.Container>
    </div>
  );
};